<template>
  <span>
    <b-dropdown
      v-if="editable"
      ref="dropdown"
      aria-role="list"
      position="is-bottom-left"
      append-to-body
    >
      <template #trigger="{ active }">
        <b-button
          :loading="loading"
          size="is-small"
          :icon-left="minimal ? 'package-variant' : ''"
          :type="minimal ? get(value).color : ''"
          :icon-right="active ? 'chevron-up' : 'chevron-down'"
        >
          <template v-if="!minimal">
            <span :class="['is-circle', get(value).color]" />
            {{ get(value).text }}
          </template>
        </b-button>
      </template>
      <b-dropdown-item :focusable="false" aria-role="menu-item" custom>
        <div class="buttons buttons-center">
          <b-button
            v-for="row in statuses"
            :key="row"
            size="is-small-1"
            class="is-fullwidth"
            @click="changeStatus(row)"
          >
            <span :class="['is-circle', get(row).color]" />
            {{ get(row).text }}
          </b-button>
        </div>
      </b-dropdown-item>
    </b-dropdown>
    <!-- KLIENT -->
    <div v-else class="order-status-tag">
      <b-icon v-if="!noIcon" icon="delivery" size="is-small" />
      <span class="tag" :class="get(value).color">
        {{ get(value).text }}
      </span>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    minimal: {
      type: Boolean
    },
    editable: {
      type: [Number, Boolean],
      default: null
    },
    noIcon: {
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      statuses: ['PROGRESS', 'COMPLETED', 'CANCELED']
    }
  },
  methods: {
    changeStatus (status) {
      this.loading = true
      this.$refs.dropdown.toggle()
      this.$api.admin.order.shipping(this.editable, status)
        .then((res) => {
          this.loading = false
          this.$buefy.toast.open({
            message: this.$t('admin.orderDetails.changeShippingStatus.success'),
            type: 'is-success'
          })
          this.$emit('input', status)
        })
        .catch(() => {
          this.loading = false
          this.$buefy.toast.open({
            message: this.$t('admin.orderDetails.changeShippingStatus.error'),
            type: 'is-danger'
          })
        })
    },
    get (status) {
      if (status && status.includes('COMPLETED')) {
        return {
          color: 'is-success',
          text: this.$t('admin.order.shippingStatuses.COMPLETED')
        }
      } else if (status && status.includes('CANCELED')) {
        return {
          color: 'is-danger',
          text: this.$t('admin.order.shippingStatuses.CANCELED')
        }
      } else {
        return {
          color: 'is-warning',
          text: this.$t('admin.order.shippingStatuses.PROGRESS')
        }
      }
    }
  }
}
</script>
